import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "ss_user_geo"

export default class extends Controller {
  static values = {
    ask: { type: Boolean, default: true }
  }

  connect() {
    if (!navigator.geolocation) return

    const cached = this.readCache()
    if (cached) {
      this.publish(cached.lat, cached.lng, { cached: true })
      return
    }

    if (this.askValue) this.locate({ silent: true })
  }

  locate(eventOrOptions = {}) {
    const silent = eventOrOptions?.silent === true || eventOrOptions?.params?.silent === true
    if (!navigator.geolocation) {
      if (!silent) this.dispatch("denied", { detail: { reason: "unsupported" } })
      return
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude
        const lng = pos.coords.longitude
        this.writeCache(lat, lng)
        this.publish(lat, lng, { cached: false })
      },
      () => {
        if (!silent) this.dispatch("denied", { detail: { reason: "denied" } })
        document.dispatchEvent(new CustomEvent("geo:denied", { bubbles: true }))
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    )
  }

  publish(lat, lng, meta = {}) {
    const detail = { lat, lng, ...meta }
    this.dispatch("located", { detail })
    document.dispatchEvent(new CustomEvent("geo:located", { detail, bubbles: true }))
  }

  readCache() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY)
      if (!raw) return null
      const data = JSON.parse(raw)
      if (typeof data.lat !== "number" || typeof data.lng !== "number") return null
      return data
    } catch (_) {
      return null
    }
  }

  writeCache(lat, lng) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng, at: Date.now() }))
    } catch (_) {}
  }
}
